import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: (resolve) => require(['../views/login.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    },
    {
      path: '/register',
      name: 'register',
      component: (resolve) => require(['../views/register.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    },
    {
      path: '/index',
      name: '',
      component: (resolve) => require(['../views/index.vue'], resolve),
      hidden: true,
      children: [
        // {
        //   path: '/',
        //   name: 'aside',
        //   component: (resolve) => require(['../components/aside.vue'], resolve),
        //   hidden: true,
        // },
        {
          path: '/',
          name: 'padList',
          component: (resolve) => require(['../views/padList/padList.vue'], resolve),
          hidden: true,
        },
       
        {
          path: '/syncPad',
          name: 'syncPad',
          component: (resolve) => require(['../views/padList/syncPad.vue'], resolve),
          hidden: true,
        },
        {
          path: '/order',
          name: 'order',
          component: (resolve) => require(['../views/order/orderPage.vue'], resolve),
          hidden: true,
        },
        {
          path: '/orderCon',
          name: 'orderCon',
          component: (resolve) => require(['../views/order/orderConfirm.vue'], resolve),
          hidden: true,
        },
        {
          path: '/goods',
          name: 'goods',
          component: (resolve) => require(['../views/goods/goods.vue'], resolve),
          hidden: true,
        },
        {
          path: '/padTransfer',
          name: 'padTransfer',
          component: (resolve) => require(['../views/padTransfer/padTransfer.vue'], resolve),
          hidden: true,
        },
        {
          path: '/coupons',
          name: 'coupons',
          component: (resolve) => require(['../views/coupons/coupons.vue'], resolve),
          hidden: true,
        },
        {
          path: '/integral',
          name: 'integral',
          component: (resolve) => require(['../views/coupons/integral.vue'], resolve),
          hidden: true,
        },
        {
          path: '/apkList',
          name: 'apkList',
          component: (resolve) => require(['../views/upload/apkList.vue'], resolve),
          hidden: true,
        },
        {
          path: '/fileList',
          name: 'fileList',
          component: (resolve) => require(['../views/upload/fileList.vue'], resolve),
          hidden: true,
        },
        {
          path: '/service',
          name: 'service',
          component: (resolve) => require(['../views/service/services.vue'], resolve),
          hidden: true,
        },
      ]
    },
    {
      path: '/serviceDetail',
      name: 'serviceDetail',
      component: (resolve) => require(['../views/service/serviceDetail.vue'], resolve),
      hidden: true,
    },
    {
      path: '/serviceBuy',
      name: 'serviceBuy',
      component: (resolve) => require(['../views/service/serviceBuy.vue'], resolve),
      hidden: true,
    },
    {
      path: '/uploadFile',
      name: 'uploadFile',
      component: (resolve) => require(['../views/upload/uploadFile.vue'], resolve),
      hidden: true,
    },
    {
      path: '/uploadApk',
      name: 'uploadApk',
      component: (resolve) => require(['../views/upload/uploadApk.vue'], resolve),
      hidden: true,
    },
    {
      path: '/handoutFile',
      name: 'handoutFile',
      component: (resolve) => require(['../views/upload/handoutFile.vue'], resolve),
      hidden: true,
    },
    {
      path: '/handoutApk',
      name: 'handoutApk',
      component: (resolve) => require(['../views/upload/handoutApk.vue'], resolve),
      hidden: true,
    },
   
    {
      path: '/documentation',
      name: 'documentation',
      component: (resolve) => require(['../views/service/documentation.vue'], resolve),
      hidden: true,
    },
    {
      path: '/msgCenter',
      name: 'msgCenter',
      component: (resolve) => require(['../views/msgCenter/index.vue'], resolve),
      hidden: true,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js